
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { NextSeo } from "@components/seo";
import parse from "html-react-parser";
import Image from "next/image";
import Link from "next/link";
import type { GetStaticProps, NextPage } from "next/types";
import useTranslation from "next-translate/useTranslation";
import { PAGE } from "../consts/ppages";
import { getPageById } from "../utils/get-page";
interface IPage {
    page: {
        title: string;
        content: string;
        aboutPage: {
            awardsTitle: string;
            awardsContent: string;
            innovationContent: string;
            innovationTitle: string;
            technologyContent: string;
            technologyTitle: string;
            title: string;
            awardsImages: {
                image: {
                    sourceUrl: string;
                };
                year: string;
                title: string;
            }[];
        };
        en: {
            title: string;
            content: string;
            aboutPage: {
                awardsTitle: string;
                awardsContent: string;
                innovationContent: string;
                innovationTitle: string;
                technologyContent: string;
                technologyTitle: string;
                title: string;
                awardsImages: [
                    image: {
                        sourceUrl: string;
                    }
                ];
            };
        };
    };
}
const About: NextPage<IPage> = ({ page }) => {
    const { t, lang } = useTranslation("common");
    const Video = {
        cs: "https://www.youtube.com/embed/AYAROw6HSQ8",
        de: "https://www.youtube.com/embed/EiiqNIwmnRE",
        en: "https://www.youtube.com/embed/AYAROw6HSQ8",
        fr: "https://www.youtube.com/embed/AYAROw6HSQ8",
        hu: "https://www.youtube.com/embed/AYAROw6HSQ8",
        it: "https://www.youtube.com/embed/SAbMrLVyF7U",
        pl: "https://www.youtube.com/embed/R0HGcK_3-fs",
    };
    return (<>
      <NextSeo languageAlternates={[
            { href: "https://knsokna.pl/about-us", hrefLang: "x-default" },
            { href: "https://knswindows.com/about-us", hrefLang: "en" },
            { href: "https://knsokna.pl/about-us", hrefLang: "pl" },
            { href: "https://knsfenster.de/about-us", hrefLang: "de" },
            { href: "https://kns-okna.eu/about-us", hrefLang: "cs" },
            { href: "https://knsfinestre.it/about-us", hrefLang: "it" },
            { href: "https://knsfenetres.fr/about-us", hrefLang: "fr" },
            { href: "https://knsokna.eu/about-us", hrefLang: "hu" },
        ]}/>
      <div className="bg-white">
        <div className="w-full bg-black text-white">
          <Image alt="about" className="w-full" height="601" src="/img/kns-production.jpg" width="1676"/>
          <div className="mx-auto max-w-7xl px-4 py-6 text-center sm:px-6 lg:px-8 lg:py-6">
            <h1 className="my-3 inline-block bg-gradient-to-r from-red to-orange px-4 py-1 font-bold text-white text-xl">
              {page?.aboutPage?.title
            ? page.aboutPage?.title
            : page?.en?.aboutPage?.title}
            </h1>
            <div className="py-3">
              {parse(page?.content ? page?.content : page?.en?.content || "")}
            </div>
          </div>
        </div>

        <div className="mx-auto max-w-7xl px-4 py-12 text-center sm:px-6 lg:px-8 lg:py-16">
          ...
        </div>

        <div className="w-full bg-black text-white">
          <div className="mx-auto max-w-7xl px-4 py-6 text-center sm:px-6 lg:px-8 lg:py-6">
            <h1 className="my-3 inline-block bg-gradient-to-r from-red to-orange px-4 py-1 font-bold text-white text-xl">
              {page.aboutPage?.innovationTitle
            ? page.aboutPage?.innovationTitle
            : page?.en?.aboutPage?.innovationTitle}
            </h1>
            <div className="py-3">
              {parse(page?.aboutPage?.innovationContent
            ? page.aboutPage?.innovationContent
            : page?.en?.aboutPage?.innovationContent)}
            </div>
          </div>
          <div className="relative mx-auto h-0 max-w-7xl overflow-hidden" style={{ paddingBottom: "56.25%" }}>
            <iframe allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" className="absolute top-0 left-0 h-full w-full" src={Video[lang]} title="YouTube video player"/>
          </div>
        </div>

        <div className="w-full pb-6">
          <div className="mx-auto max-w-7xl px-4 py-6 text-center sm:px-6 lg:px-8 lg:py-6">
            <h1 className="my-3 inline-block bg-gradient-to-r from-red to-orange px-4 py-1 font-bold text-white text-xl">
              {page.aboutPage?.technologyTitle
            ? page.aboutPage?.technologyTitle
            : page?.en?.aboutPage?.technologyTitle}
            </h1>
            <div className="py-3">
              {parse(page?.aboutPage?.technologyContent
            ? page.aboutPage?.technologyContent
            : page?.en?.aboutPage?.technologyContent)}
            </div>
          </div>
          <div className="flex justify-center text-center">
            <div className="max-w-[160px]">
              <Link className="uppercase" href="/certificates">
                <Image alt="certifications" height="363" src="/img/about/certificates.png" width="362"/>
                {t("certificates")}
              </Link>
            </div>
            <div className="max-w-[160px]">
              <Link href="/pvc/v-perfect">
                <Image alt="v-perfect" height="363" src="/img/about/v_perfect.png" width="363"/>
                V-PERFECT
              </Link>
            </div>
          </div>
        </div>

        <div className="w-full bg-black text-white">
          <Image alt="about" height="612" src="/img/quality.jpg" width="1724"/>
          <div className="mx-auto max-w-7xl px-4 py-6 text-center sm:px-6 lg:px-8 lg:py-6">
            <h1 className="my-3 inline-block bg-gradient-to-r from-red to-orange px-4 py-1 font-bold text-white text-xl">
              {page.aboutPage?.awardsTitle
            ? page.aboutPage?.awardsTitle
            : page?.en?.aboutPage?.awardsTitle}
            </h1>
            <div className="py-3">
              {parse(page?.aboutPage?.awardsContent
            ? page.aboutPage?.awardsContent
            : page?.en?.aboutPage?.awardsContent)}
            </div>
          </div>
        </div>
        <div className="bg-white">
          <div className="mx-auto max-w-7xl px-4 py-6 text-center sm:px-6 lg:px-8 lg:py-6">
            <div className="grid grid-cols-2 gap-4 text-left md:grid-cols-4 lg:grid-cols-6">
              {page?.aboutPage?.awardsImages?.map((award) => (<div className="flex flex-col" key={`${award.year}-${award.title}`}>
                  <Link href={award.image.sourceUrl} target="_blank">
                    <Image alt="about" height="60" src={award.image.sourceUrl} width="130"/>
                  </Link>
                  Rok: {award.year}
                  <br />
                  {award.title}
                </div>))}
            </div>
          </div>
        </div>
      </div>
    </>);
};
const getStaticProps: GetStaticProps = async (context) => {
    const locale = context.locale || "PL";
    const LOCALE = locale === "cz" ? "CS" : locale.toUpperCase();
    const PAGE_ID = PAGE.ABOUTUS[LOCALE as keyof typeof PAGE.ABOUTUS] || 1;
    const { page } = await getPageById(PAGE_ID);
    return {
        props: {
            page,
        },
    };
};
export default About;

    async function __Next_Translate__getStaticProps__1a19cd2bec8__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/about-us',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a19cd2bec8__ as getStaticProps }
  